import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const useInvList = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  return useQuery({
    queryKey: ["inv-list", searchParams.get("sortOrder")],
    queryFn: async () => {
      const urlKey = t("inv-listing");
      const response = await axios.get(urlKey, {
        params: {
          sortOrder: searchParams.get("sortOrder") ?? "desc",
        }
      });
      return response.data.data;
    },
    refetchOnWindowFocus: false
  });
};
